// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hpok","type":"styles_type__3y8WR","choices":"styles_choices__1PkVY"};